import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export type SeriesResponse = {
  labels: string[];
  values: number[];
};

export type TimeRangeParams = { startTime: string; endTime: string };
export type TotalResponse = { total: number };

export type ConversionRateResponse = {
  totalAppointments: number;
  appointmentsWithSale: number;
  conversionRatePercent: number;
};

export type CustomerConversionRateResponse = {
  uniqueCustomers: number;
  uniqueCustomersWithSale: number;
  conversionRatePercent: number;
};

const qs = (params: Record<string, string | number | undefined>) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) sp.append(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
};

const CustomersCrmStatisticsAPI = {
  getInboundChannels: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<SeriesResponse>(
      `/v1/statistics/customers-crm/summary/inbound-channels${qs({ startTime, endTime })}`
    ),

  getTotalOverTime: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<SeriesResponse>(
      `/v1/statistics/customers-crm/summary/total-over-time${qs({ startTime, endTime })}`
    ),

  getCustomersTotal: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<TotalResponse>(
      `/v1/statistics/customers-crm/summary/total${qs({ startTime, endTime })}`
    ),

  getConversionRate: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<ConversionRateResponse>(
      `/v1/statistics/customers-crm/summary/conversion-rate${qs({ startTime, endTime })}`
    ),

  getCustomerConversionRate: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<CustomerConversionRateResponse>(
      `/v1/statistics/customers-crm/summary/conversion-rate-customers${qs({ startTime, endTime })}`
    ),
};

export default CustomersCrmStatisticsAPI;


